import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "plasper_session_token";

export function saveSessionToken(token) {
  if (token) {
    try { localStorage.setItem(TOKEN_KEY, token); } catch { /* private mode */ }
  }
}

export function getSessionToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}

export function clearSessionToken() {
  try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
}

// Auth strategy:
//   1) httpOnly cookie via `withCredentials: true` (default, ideal path)
//   2) FALLBACK: `Authorization: Bearer <token>` from localStorage
//   Some browsers (Safari iOS, mobile Chrome with strict tracking prevention)
//   block SameSite=None cookies. Bearer header makes auth resilient there.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const token = getSessionToken();
  if (token) {
    cfg.headers = cfg.headers || {};
    if (!cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

// Global 401 handler: session invalid/expired → clear token & redirect to /login.
// Skip for /auth/me (used by AuthContext to probe session) so it can resolve to null user cleanly.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.includes("/auth/me") && !url.includes("/auth/logout")) {
      clearSessionToken();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
